import React, { useState } from "react";
import { FcBusinessman, FcLeft, FcPrevious } from "react-icons/fc";
import { useNavigate } from "react-router";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import Footer from "../../../../Kryzen Alpha App/Components/Footer/footer";
import { useSelector } from "react-redux";
import { Field, Form, Formik } from "formik";
import SimpleButton from "../../../Components/layouts/simple_button";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import CustomInput from "../../../CustomComponent/custom_input";
import { IoIosArrowBack } from "react-icons/io";
import { deliveryPartnerInfo } from "../../../SchemaInfo/Epg Info/deliveryPartnerInfo";
import { deliveryPartnerSchema } from "../../../Schemas/Epg Farmer/delivery_partner_shcema";

const OnboardDeliveryPartner = () => {
  const navigate = useNavigate();
  const store = useSelector((store) => store?.login?.user);

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    console.log("reached here", values);

    try {
      setLoading(true);

      let formData = new FormData();
      for (let key in values) {
        formData.append(key, values[key]);
      }
      const headers = { "Content-Type": "multipart/form-data" };
      const res = await performRequest(
        "POST",
        "/pmg/delivery-partner/create-delivery-partner",
        formData,
        headers
      );

      if (res?.status === 200 || res?.status === 201) {
        Toast("success", "Delivery Partner onboarded successfully!");
        navigate("/farmer-partners");
      } else {
        Toast("error", "Unable to onboard farmer partner");
      }
    } catch (err) {
      if (err.response?.data?.message) {
        Toast("error", err.response?.data?.message);
      } else {
        CustomErrorResponse(err);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none m-0">
            <div className="col d-flex justify-content-between">
              <div>
                <h2 className="page-title mb-1 mt-4">
                  <FcBusinessman className="fs-2 me-1" /> Onboard Delivery
                  Partner
                </h2>
                <h4 className="text-muted m-0 p-0">
                  register a new delivery partner.
                </h4>
              </div>
              <div className="mt-4">
                <button
                  className="btn btn-secondary"
                  onClick={() => navigate("/farmer-partners")}
                >
                  <IoIosArrowBack /> Back
                </button>
              </div>
            </div>
          </div>

          <div className="row py-3">
            <div className="col-md-3 col-sm-12 mb-3 py-2">
              <div className="card p-3">
                <h4 className="mb-3">Quick Notes</h4>
                <ul className="mb-0 ps-3">
                  <li>Farmer Partner Id is mandatory</li>
                  <li>Email and contact number should be unique</li>
                </ul>
              </div>
            </div>

            <div className="col-md-9 col-sm-12 py-2">
              <div className="card p-4">
                <Formik
                  initialValues={deliveryPartnerInfo}
                  validationSchema={deliveryPartnerSchema}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {(props) => (
                    <Form>
                      {console.log(props, "this is prop")}
                      <div className="card-body">
                        <div className="row g-3">
                          {/* Client Id */}
                          <div className="col-md-4">
                            <label className="form-label required">
                              Farmer Partner
                            </label>
                            <CustomInput name="farmerPartnerId" type="text" />
                            {props.touched.farmerPartnerId &&
                              props.errors.farmerPartnerId && (
                                <p className="text-danger">
                                  {props.errors.farmerPartnerId}
                                </p>
                              )}
                          </div>

                          {/* Farmer Name */}
                          <div className="col-md-4">
                            <label className="form-label required">
                              Delivery Partner Name
                            </label>
                            <CustomInput
                              name="deliveryPartnerName"
                              type="text"
                            />
                            {props.touched.deliveryPartnerName &&
                              props.errors.deliveryPartnerName && (
                                <p className="text-danger">
                                  {props.errors.deliveryPartnerName}
                                </p>
                              )}
                          </div>

                          {/* Email */}
                          <div className="col-md-4">
                            <label className="form-label required">Email</label>
                            <CustomInput name="email" type="email" />
                            {props.touched.email && props.errors.email && (
                              <p className="text-danger">
                                {props.errors.email}
                              </p>
                            )}
                          </div>

                          {/* Contact */}
                          <div className="col-md-4">
                            <label className="form-label required">
                              Contact Number
                            </label>
                            <CustomInput
                              name="contactNumber"
                              type="text"
                              maxLength={10}
                            />
                            {props.touched.contactNumber &&
                              props.errors.contactNumber && (
                                <p className="text-danger">
                                  {props.errors.contactNumber}
                                </p>
                              )}
                          </div>

                          {/* Alternate Contact */}
                          <div className="col-md-4">
                            <label className="form-label">
                              Alternate Contact
                            </label>
                            <CustomInput
                              name="alternateContactNumber"
                              type="text"
                              maxLength={10}
                            />
                          </div>

                          {/* Address */}
                          <div className="col-md-6">
                            <label className="form-label">Address Line 1</label>
                            <CustomInput name="addressLine1" type="text" />
                          </div>

                          <div className="col-md-6">
                            <label className="form-label">Address Line 2</label>
                            <CustomInput name="addressLine2" type="text" />
                          </div>

                          {/* Location */}
                          <div className="col-md-4">
                            <label className="form-label">Village</label>
                            <CustomInput name="village" type="text" />
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">City</label>
                            <CustomInput name="city" type="text" />
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">State</label>
                            <CustomInput name="state" type="text" />
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">Pincode</label>
                            <CustomInput name="pincode" type="text" />
                            {props.touched.pincode && props.errors.pincode && (
                              <p className="text-danger">
                                {props.errors.pincode}
                              </p>
                            )}
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">Landmark</label>
                            <CustomInput name="landmark" type="text" />
                          </div>

                          {/* Geo */}
                          <div className="col-md-4">
                            <label className="form-label">Vehicle Type</label>
                            <CustomInput name="vehicleType" type="number" />
                            {props.touched.vehicleType &&
                              props.errors.vehicleType && (
                                <p className="text-danger">
                                  {props.errors.vehicleType}
                                </p>
                              )}
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">Vehicle Number</label>
                            <CustomInput name="longitude" type="number" />
                            {props.touched.vehicleNumber &&
                              props.errors.vehicleNumber && (
                                <p className="text-danger">
                                  {props.errors.vehicleNumber}
                                </p>
                              )}
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">
                              Driving License Number
                            </label>
                            <CustomInput
                              name="drivingLicenseNumber"
                              type="number"
                            />
                            {props.touched.drivingLicenseNumber &&
                              props.errors.drivingLicenseNumber && (
                                <p className="text-danger">
                                  {props.errors.drivingLicenseNumber}
                                </p>
                              )}
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">
                              Driving License Image
                            </label>

                            <CustomInput
                              name="drivingLicenseImage"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "drivingLicenseImage",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.drivingLicenseImage &&
                              props.errors.drivingLicenseImage && (
                                <p className="text-danger">
                                  {props.errors.drivingLicenseImage}
                                </p>
                              )}
                          </div>

                          {/* <div className="col-md-6">
                            <label className="form-label">Profile Image</label>

                            <CustomInput
                              name="profileImage"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "profileImage",
                                  e.target.files[0]
                                )
                              }
                            />
                          </div> */}

                          <div className="col-md-6">
                            <label className="form-label">Notes</label>
                            <CustomInput name="notes" type="text" />
                          </div>

                          {/* Checkbox */}
                          <div className="col-md-3">
                            <div className="form-check mt-4">
                              <input
                                type="checkbox"
                                name="isActive"
                                checked={props.values.isActive}
                                onChange={props.handleChange}
                                className="form-check-input"
                              />
                              <label className="form-check-label">
                                Is Active
                              </label>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-check mt-4">
                              <input
                                type="checkbox"
                                name="isAvailable"
                                checked={props.values.isAvailable}
                                // onChange={props.handleChange}
                                className="form-check-input"
                              />
                              <label className="form-check-label">
                                Is Available
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Footer */}
                      <div className="card-footer">
                        <div className="d-flex gap-2 justify-content-end">
                          <FormSubmitButton
                            buttonText={
                              loading
                                ? "Submitting..."
                                : "Create Delivery Partner"
                            }
                          />
                          <SimpleButton
                            buttonText="Cancel"
                            type="secondary"
                            onClick={() => navigate("/farmer-partner")}
                          />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default OnboardDeliveryPartner;
